import { Box, BoxProps, Text } from "@chakra-ui/react";
import { useRef } from "react";

export function ErrorBox({
  children,
  errorMessage,
  messageErrorProps,
  border,
  ...rest
}: { errorMessage?: string; messageErrorProps?: BoxProps } & BoxProps) {
  const errorBox = useRef<HTMLDivElement>(null);

  const onFocusIn = () => {
    if (errorMessage && errorBox.current) {
      errorBox.current.style.transform = `scale(0.8)`;
      errorBox.current.style.visibility = `hidden`;
      errorBox.current.style.opacity = `0`;
    }
  };
  const onFocusOut = () => {
    if (errorBox.current) {
      errorBox.current.style.transform = ``;
      errorBox.current.style.visibility = ``;
      errorBox.current.style.opacity = ``;
    }
  };

  return (
    <Box
      pos="relative"
      role="group"
      onFocus={() => onFocusIn()}
      onBlur={() => onFocusOut()}
    >
      <Box
        {...rest}
        border={
          errorMessage ? "3px solid var(--chakra-colors-secondary-600)" : border
        }
      >
        {children}
      </Box>
      {errorMessage ? (
        <Box
          ref={errorBox}
          bg="secondary.700"
          maxW="80%"
          minW="26px"
          pos="absolute"
          borderRadius="10px"
          p="3px"
          right={0}
          bottom="-16px"
          zIndex="10"
          border="1px solid var(--chakra-colors-secondary-400)"
          transition="0.2s"
          transform="scale(0.8) translateY(50%)"
          visibility="hidden"
          opacity={0}
          _groupHover={{
            transform: "scale(1)",
            visibility: "visible",
            opacity: "1"
          }}
        >
          <Box
            w="10px"
            h="10px"
            zIndex="-1"
            transform="rotate(45deg)"
            top="-6px"
            bg="secondary.700"
            right="10px"
            pos="absolute"
            borderTop="1px solid var(--chakra-colors-secondary-400)"
            borderLeft="1px solid var(--chakra-colors-secondary-400)"
            borderRadius="0 0 10px 0"
          />
          <Text
            color="#fff"
            fontWeight="bold"
            fontSize="9"
            whiteSpace="pre-wrap"
            {...messageErrorProps}
          >
            {errorMessage}&nbsp;
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}
